import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { ReactComponent as CloseIcon } from 'assets/svg/close.svg';
import classNames from 'classnames';
import './ModalGeneric.scss';

export default function ModalGeneric(props) {
  const {
    className,
    actions,
    title,
    children,
    open,
    onModalClose,
    showCloseButton,
    ...rest
  } = props;

  return (
    <Modal
      open={open}
      onClose={onModalClose}
      className={classNames(className, 'generic-modal')}
      {...rest}
    >
      {showCloseButton || title ? (
        <Modal.Header>
          {showCloseButton ? (
            <Button
              className="close-icon borderless"
              basic
              icon
              floated="right"
              onClick={onModalClose}
            >
              <CloseIcon />
            </Button>
          ) : null}
          {title}
        </Modal.Header>
      ) : null}

      {children ? <Modal.Content>{children}</Modal.Content> : null}
      {actions ? <Modal.Actions>{actions}</Modal.Actions> : null}
    </Modal>
  );
}
